import { format, isValid } from "date-fns";

export const getEighteenYearsAgo = (): Date => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  today.setHours(0, 0, 0, 0); // Reset time to 00:00:00
  return today;
};

export const formatMuiFormDate = (
  isoDate?: string,
  dataFormat?: string
): string | undefined => {
  if (!isoDate) {
    return undefined; // Return an empty string instead of throwing an error
  }

  try {
    // Remove time zone (PST, EST) & match format exactly
    const parsedDate = new Date(isoDate);

    return isValid(parsedDate)
      ? format(parsedDate, dataFormat || "yyyy-MM-dd")
      : undefined; // Convert to YYYY-MM-DD format
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return undefined; // Handle errors gracefully
  }
};

export const formatRequestDate = (date?: Date): string | undefined => {
  return date ? new Date(date).toISOString().split("T")[0] : undefined;
};
